var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudLeftDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 108,
    viewBox: "0 0 177 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.786 54.0552C146.786 54.0004 146.788 53.9461 146.788 53.8913C146.788 24.1613 122.87 0.0604248 93.3656 0.0604248C71.49 0.0604248 52.6886 13.3118 44.4274 32.2811C42.3318 31.9175 40.1784 31.7258 37.98 31.7258C17.1538 31.7258 0.270508 48.7383 0.270508 69.724C0.270508 90.7097 17.1538 107.722 37.98 107.722H149.734C164.486 107.722 176.444 95.6716 176.444 80.8065C176.444 65.9415 164.486 53.8913 149.734 53.8913C148.737 53.8913 147.754 53.9481 146.786 54.0552Z",
    fill: "url(#paint0_linear_166_5832)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_166_5832",
    x1: 88.3574,
    y1: 73.8722,
    x2: 81.9751,
    y2: 27.6362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudLeftDesktop);
export default __webpack_public_path__ + "static/media/cloud-left-desktop.e1bfd1e192206c145f9ad39d49ab56ab.svg";
export { ForwardRef as ReactComponent };